
/* eslint-disable */

// app
export const SET_LANGUAGE = 'set_language';
export const SET_CURRENCY = 'set_currency';
export const SET_REGION = 'set_region';
export const SET_TIMESTAMP_DIFF = 'set_timestamp_diff';
export const SET_OPEN_OFF_CANVAS = 'set_open_off_canvas';
export const SET_OFF_CANVAS_ACTIVE = 'set_off_canvas_active';
export const SET_SEARCH_TOOL_OPENED = 'set_search_tool_opened';
export const SET_FROM_ROUTE = 'set_from_route';
export const SET_TRACK_ID = 'set_track_id';
export const SET_SEARCH_KEYWORD = 'set_search_keyword';
export const SET_SEARCH_PLATFORM = 'set_search_platform';

// ad
export const RECEIVE_AD = 'receive_ad';

// config
export const RECEIVE_CONFIGS = 'receive_configs';

// product
export const RECEIVE_PRODUCTS_NEW_ARRIVAL = 'receive_products_new_arrival';
export const RECEIVE_PRODUCTS_RECOMMEND = 'receive_products_recommend';
export const RECEIVE_PRODUCTS_ADD_PURCHASE = 'receive_products_add_purchase';
export const RECEIVE_PRODUCTS_HOT = 'receive_products_hot';
export const RECEIVE_PRODUCTS_DETAIL = 'receive_products_detail';
export const RECEIVE_PRODUCTS_GENERAL = 'receive_products_general';
export const RECEIVE_PRODUCTS_SALE = 'receive_products_sale';
export const RECEIVE_PRODUCTS = 'receive_products';
export const RECEIVE_PRODUCT_CATEGORIES = 'receive_product_categories';
export const RECEIVE_PRODUCT_BRANDS = 'receive_product_brands';
export const RECEIVE_PRODUCT_SOURCE = 'receive_product_source';
export const RECEIVE_FEE = 'receive_fee';

// user
export const RECEIVE_USER_TOKEN = 'receive_user_token';
export const SET_TOKEN = 'set_token';
export const SET_EXPIRE_TIME = 'set_expire_time';
export const REMOVE_TOKEN = 'remove_token';
export const REVEIVE_IDENTITY = 'reveive_identity';
export const RECEIVE_WISHLIST = 'receive_wishlist';
export const ADD_TO_WISHLIST = 'add_to_wishlist';
export const REMOVE_WISHLIST_ITEM = 'remove_wishlist_item';
export const EMPTY_WISHLIST = 'empty_wishlist';
export const RECEIVE_SHIPPING_ADDRESS = 'receive_shipping_address';
export const EMPTY_SHIPPING_ADDRESS = 'empty_shipping_address';
export const ADD_SHIPPING_ADDRESS = 'add_shipping_address';
export const UPDATE_SHIPPING_ADDRESS = 'update_shipping_address';
export const DELETE_SHIPPING_ADDRESS = 'delete_shipping_address';
export const SET_DEFAULT_SHIPPING_ADDRESS = 'set_default_shipping_address';
export const SET_SHIPPING_ADDRESS_DIALOG = 'set_shipping_address_dialog';
export const RECEIVE_DISTRICTS = 'receive_districts';
export const RECEIVE_HISTORY = 'receive_history';
export const NEW_HISTORY = 'new_history';
export const EMPRY_HISTORY = 'empry_history';
export const COUPON_LIST = 'coupon_list'

// cart
export const EMPTY_CART = 'empty_cart';
export const SET_SHOWCART = 'set_showcart';
export const REMOVE_CART_ITEM = 'remove_cart_item';
export const RECEIVE_CARTS = 'receive_carts';
export const ADD_TO_CART = 'add_to_cart';
export const UPDATE_CART = 'update_cart';
export const SET_CART_SELECTED_IDS = 'set_cart_selected_ids';
// third party shop cart
export const ADD_THIRD_PARTY_SHOP_CART = 'add_third_party_shop_cart';
export const REVEICE_THIRD_PARTY_SHOP_CARTS = 'reveice_third_party_shop_carts';
export const UPDATE_THIRD_PARTY_SHOP_CART = 'update_third_party_shop_cart';
export const REMOVE_THIRD_PARTY_SHOP_CART = 'remove_third_party_shop_cart'

// order
export const EMPTY_ORDERS = 'empty_orders';
export const RECEIVE_ORDERS = 'receive_orders';
export const RECEIVE_ORDERS_BY_ID = 'receive_orders_by_id';
export const NEW_ORDER = 'new_order';
export const DELETE_ORDER = 'delete_order';
export const SET_CHECKOUT_IDS = 'set_checkout_ids';

// article
export const RECEIVE_ARTICLES_DETAIL = 'receive_articles_detail';
export const RECEIVE_ARTICLE_BY_CATEGORY = 'receive_article_by_category';

// faq
export const RECEIVE_FAQ = 'receive_faq';
export const RECEIVE_TAGE = 'receive_tage';

//proxy
export const RECEIVE_PROXY_REQUEST = 'receive_proxy_request';
export const UPDATE_PROXY_REQUEST = 'update_proxy_request';
export const CREATE_PROXY_REQUEST = 'create_proxy_request';
export const DELETE_PROXY_REQUEST = 'delete_proxy_request';

// rakuten
export const RECEIVE_RAKUTEN_RANKING = 'receive_rakuten_ranking';
export const RECEIVE_RAKUTEN_ITEM = 'receive_rakuten_item';

// yahoo
export const RECEIVE_YAHOO_ITEM = 'receive_yahoo_item';

// amazon
export const RECEIVE_AMAZON_ITEM = 'receive_amazon_item';

// third party wishlist
export const RECEIVE_THIRD_PARTY_SHOP_WISHLIST = 'receive_third_party_shop_wishlist';
export const ADD_TO_THIRD_PARTY_WISHLIST = 'add_to_third_party_wishlist';
export const REMOVE_THIRD_PARTY_SHOP_WISHLIST_ITEM = 'remove_third_party_shop_wishlist_item';

// transportation
export const RECEIVE_WARAHOUSES = 'receive_warahouses';
export const RECEIVE_OVERSEAS_WAREHOUSES = 'receive_overseas_warehouses';
export const RECEIVE_PARCEL_CLAIM = 'receive_parcel_claim';
export const RECEIVE_NEW_PARCEL_CLAIM = 'receive_new_parcel_claim';
export const REMOVE_CLAIM = 'remove_claim';
export const RECEIVE_PARCEL = 'receive_parcel';
export const RECEIVE_PARCEL_COUNT = 'receive_parcel_count';
export const RECEIVE_PARCEL_DETAIL = 'receive_parcel_detail';
export const RECEIVE_SETTINGS = 'receive_settings';
export const RECEIVE_ORDER_DETAIL = 'receive_order_detail';
export const RECEIVE_ORDER_UNPAID_COUNT = 'receive_order_unpaid_count';
